$(function () {
  $('form').submit(function () {
	if (!$("form").valid())
	  return false;

	$("#errors,form input[type=submit]").addClass("hide");
	$(".saving").removeClass("hide");

	$.ajax({
	  url: $(this).attr('action'),
	  type: 'POST',
	  dataType: "json",
	  data: $(this).serialize(),
	  success: function (data) {
		var inModal = parent.$("#iframe-modal .modal-body").length > 0;

		if (data.Status == "OK") {
		  if (inModal) {
			parent.ShowSavedPopup("Your contact request has been sent successfully.", "");
			parent.$("#iframe-modal").modal("hide");
		  }
		  else {
			$("#success-message").removeClass("hide");
			$("#form-fields").addClass("hide");
		  }
		}
		else {
		  $("#errors,form input[type=submit]").removeClass("hide").html(data.Errors);
		}


		$(".saving").addClass("hide");
	  },
	  error: function (jqXHR, textStatus, errorThrown) {
		$("#errors,form input[type=submit]").removeClass("hide").html(jqXHR.responseText);
		$(".saving").addClass("hide");
	  }
	});

	return false;
  });
});